import {
    UniformSlot,
    UniformSlotWrapperComponentProps
} from "@uniformdev/canvas-react";

import { GenericTableRow } from "@/libraries/design/patterns/table/src/generic-table-row.tsx";

const fragmentWrapper = ({ items }: UniformSlotWrapperComponentProps) => (
    <>{items}</>
);

const UniformTableRow = () => {
    return (
        <GenericTableRow>
            <UniformSlot name="cells" wrapperComponent={fragmentWrapper} />
        </GenericTableRow>
    );
};

export default UniformTableRow;
